import { mapState } from "vuex";
export default {
    computed:{
        ...mapState({
            allPermissions: state => state.permissions.permissions
        }),
        permissions() {
            return this.allPermissions[this.context];
        },
        disabledValue() {
            if (this.disabled || !this.permissions.actions[this.actionName]) {
                return true;
            } else {
                return false;
            }
        },
    },
    props: [
        "context",
        "disabled",
        "actionName",
    ]
}
